import { render } from "./TestimonialsPage.vue?vue&type=template&id=374edc0e&scoped=true"
import script from "./TestimonialsPage.vue?vue&type=script&lang=js"
export * from "./TestimonialsPage.vue?vue&type=script&lang=js"

import "./TestimonialsPage.vue?vue&type=style&index=0&id=374edc0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374edc0e"]])

export default __exports__